import Notifications from '@mui/icons-material/Notifications'
import GroupAdd from '@mui/icons-material/GroupAdd'
import Home from '@mui/icons-material/Home'
import Delete from '@mui/icons-material/Delete'
import Add from '@mui/icons-material/Add'
import Person from '@mui/icons-material/Person'
import Share from '@mui/icons-material/Share'
import Settings from '@mui/icons-material/Settings'
import Star from '@mui/icons-material/Star'
import Clear from '@mui/icons-material/Clear'
import Search from '@mui/icons-material/Search'

// eslint-disable-next-line import/prefer-default-export
export const ICON_DICTIONARY = {
	Notifications,
	GroupAdd,
	Home,
	Delete,
	Add,
	Person,
	Share,
	Settings,
	Star,
	Clear,
	Search,
} as const
